import { render, staticRenderFns } from "./paymentChannel.vue?vue&type=template&id=6e2ed04d&scoped=true"
import script from "./paymentChannel.vue?vue&type=script&lang=js"
export * from "./paymentChannel.vue?vue&type=script&lang=js"
import style0 from "./paymentChannel.vue?vue&type=style&index=0&id=6e2ed04d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2ed04d",
  null
  
)

export default component.exports